// Analytics consent state (GDPR/PECR opt-in).
//
// Persists the user's choice so the banner only shows until they respond, and
// analytics stays off entirely until they explicitly accept. Reading/writing is
// defensive so a disabled localStorage can never break the app.

const KEY = "analytics-consent";

export const CONSENT = {
  GRANTED: "granted",
  DENIED: "denied",
};

/** Returns "granted", "denied", or null (not yet chosen). */
export function getConsent() {
  try {
    return localStorage.getItem(KEY);
  } catch (err) {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(KEY, value);
  } catch (err) {
    // ignore
  }
}

/** True once the user has made an explicit accept/decline choice. */
export function hasResponded() {
  const c = getConsent();
  return c === CONSENT.GRANTED || c === CONSENT.DENIED;
}

export function isGranted() {
  return getConsent() === CONSENT.GRANTED;
}
